export default __webpack_public_path__ + "static/media/pictorial.68bf31c6.svg";